// "CAPLIGHT" -> "Caplight". Market-data provider codes arrive upper-cased and
// underscore-separated; this is the single place that turns one into display
// text, so the Daily NAV grid's column headers and the company-settings picker
// chips can never disagree about how a provider is spelled.
//
// Deliberately not `capitalizeWords`: that helper preserves an all-caps word by
// design, which would leave the code shouting.
const formatProviderCode = (providerCode: string): string =>
  providerCode
    .toLowerCase()
    .split(/[\s_]+/)
    .filter(Boolean)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

export default formatProviderCode;
